<template>
    <div class="home-frame">
        <Header
            class="home-header"
            :value="headerValue"
            @select="$emit('select', $event)"
        />
        <section class="hero-section" :style="heroSectionStyle">
            <img class="hero-image" :src="resolvedHeroImage" alt="page banner" />
        </section>
        <slot></slot>

        <section
            class="contact-strip"
            :class="isEnglish ? 'contact-strip-en' : 'contact-strip-zh'"
        >
            <div class="section-shell contact-shell">
                <div class="bottom2_qr">
                    <img :src="$gm('gzhqr.jpg')" alt="wechat qrcode" />
                    <span>{{ $t("home.followWechat") }}</span>
                </div>
                <div class="bottom2_right">
                    <div>
                        <template v-if="isEnglish">
                            <span class="bottom2_prefix">{{ contactPrefix }}</span>
                            <span>{{ firstContact }}</span>
                            <span>{{ secondContact }}</span>
                        </template>
                        <template v-else>
                            <span>{{ `${contactPrefix}${firstContact}` }}</span>
                            <span>{{ secondContact }}</span>
                        </template>
                    </div>
                    <div>{{ addressText }}</div>
                    <div>{{ recordText }}</div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Header from "@/components/header.vue";

export default {
    components: {
        Header,
    },
    props: {
        headerValue: {
            type: String,
            default: "0",
        },
        heroImage: {
            type: String,
            default: "2-1.png",
        },
        heroSrc: {
            type: String,
            default: "",
        },
        heroGap: {
            type: Number,
            default: 60,
        },
    },
    computed: {
        isEnglish() {
            return this.$i18n.locale === "en";
        },
        heroSectionStyle() {
            return {
                marginBottom: `${this.heroGap}px`,
            };
        },
        resolvedHeroImage() {
            return this.heroSrc || this.$gm(this.heroImage);
        },
        contactText() {
            return this.isEnglish
                ? "Contact: "
                : "联系方式：";
        },
        contactPrefix() {
            return this.contactText;
        },
        firstContact() {
            return this.isEnglish
                ? "Mr. Chen 15850576018"
                : "陈先生 15850576018";
        },
        secondContact() {
            return this.isEnglish
                ? "Ms. Zhou 15295583680"
                : "周女士 15295583680";
        },
        recordText() {
            return this.isEnglish
                ? "Record No.: Su ICP No. 05085572-16"
                : "2026 备案号：[苏ICP备05085572号-16]";
        },
        addressText() {
            return this.isEnglish
                ? "Address: Nanjing International Expo Center, 300 Jiangdong Middle Road, Jianye District, Nanjing"
                : "展会地址：南京国际博览中心（南京河西·江东中路300号）";
        },
    },
};
</script>

<style scoped lang="less">
.section-shell {
    width: 88%;
    margin: 0 auto;
}

.hero-section {
    width: 100%;
    line-height: 0;
}

.hero-image {
    width: 100%;
    display: block;
}

.contact-strip {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    margin: 0;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% 100%;
    background-image: url("~@/assets/image/home-bg-4.png");
}

.contact-shell {
    width: 100%;
    margin: 0;
    height: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    overflow: hidden;
    clear: both;
    color: #fff;
    font-size: 16px;
    line-height: 40px;
}

.bottom2_qr {
    width: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    clear: both;
}

.bottom2_qr img {
    width: 100%;
    max-width: none;
    height: auto;
    box-sizing: border-box;
}

.bottom2_qr span {
    display: block;
    line-height: inherit;
    margin-top: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    text-align: center;
}

.bottom2_right {
    width: auto;
    height: auto;
    padding-top: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    clear: both;
}

.bottom2_right > div {
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
}

.bottom2_right > div span {
    margin-right: 50px;
}

.bottom2_prefix {
    margin-right: 0 !important;
}

/* Chinese footer style: follows D:\chat\qq\html\bottom.html */
.contact-strip-zh {
    padding: 40px 10%;
}

.contact-strip-zh .contact-shell {
    font-size: 16px;
    line-height: 40px;
}

.contact-strip-zh .bottom2_qr {
    width: 20%;
    max-width: 180px;
    justify-content: flex-start;
}

.contact-strip-zh .bottom2_qr img {
    max-width: none;
}

.contact-strip-zh .bottom2_qr span {
    line-height: 40px;
    margin-top: 0;
}

.contact-strip-zh .bottom2_right {
    width: 80%;
    padding-top: 40px;
}

.contact-strip-zh .bottom2_right > div {
    width: 50%;
    margin-bottom: 20px;
}

.contact-strip-zh .bottom2_right > div span {
    margin-right: 50px;
    width: auto;
    display: inline;
}

@media (min-width: 1400px) and (max-width: 1600px) {
    .contact-strip-zh {
        padding: 40px 5%;
    }

    .contact-strip-zh .contact-shell {
        flex-wrap: nowrap;
        font-size: 16px;
        line-height: 40px;
    }

    .contact-strip-zh .bottom2_qr {
        width: 20%;
        max-width: 180px;
    }

    .contact-strip-zh .bottom2_right {
        width: 80%;
        padding-top: 40px;
    }

    .contact-strip-zh .bottom2_right > div {
        width: 50%;
        margin-bottom: 20px;
    }

    .contact-strip-zh .bottom2_right > div span {
        margin-right: 50px;
    }
}

@media (min-width: 1200px) and (max-width: 1399px) {
    .contact-strip-zh {
        padding: 40px 5%;
    }

    .contact-strip-zh .contact-shell {
        flex-wrap: nowrap;
        font-size: 16px;
        line-height: 40px;
    }

    .contact-strip-zh .bottom2_qr {
        width: 20%;
        max-width: 180px;
    }

    .contact-strip-zh .bottom2_right {
        width: 80%;
        padding-top: 40px;
    }

    .contact-strip-zh .bottom2_right > div {
        width: 50%;
        margin-bottom: 20px;
    }

    .contact-strip-zh .bottom2_right > div span {
        margin-right: 20px;
    }
}

@media (min-width: 768px) and (max-width: 1199px) {
    .contact-strip-zh {
        padding: 40px 5%;
    }

    .contact-strip-zh .contact-shell {
        flex-wrap: nowrap;
        font-size: 16px;
        line-height: 40px;
    }

    .contact-strip-zh .bottom2_qr {
        width: 20%;
        max-width: 180px;
    }

    .contact-strip-zh .bottom2_right {
        width: 75%;
        padding-top: 20px;
    }

    .contact-strip-zh .bottom2_right > div {
        width: 100%;
        margin-bottom: 10px;
    }

    .contact-strip-zh .bottom2_right > div span {
        margin-right: 20px;
    }
}

@media (min-width: 651px) and (max-width: 767px) {
    .contact-strip-zh {
        padding: 40px 5%;
    }

    .contact-strip-zh .contact-shell {
        flex-wrap: nowrap;
        font-size: 14px;
        line-height: 40px;
    }

    .contact-strip-zh .bottom2_qr {
        width: 20%;
        max-width: 180px;
    }

    .contact-strip-zh .bottom2_right {
        width: 75%;
        padding-top: 10px;
    }

    .contact-strip-zh .bottom2_right > div {
        width: 100%;
        margin-bottom: 0;
    }

    .contact-strip-zh .bottom2_right > div span {
        margin-right: 20px;
    }
}

@media screen and (max-width: 650px) {
    .contact-strip-zh {
        padding: 20px 2%;
    }

    .contact-strip-zh .contact-shell {
        flex-wrap: wrap;
        font-size: 14px;
        line-height: 30px;
    }

    .contact-strip-zh .bottom2_qr {
        width: 100%;
        max-width: 767px;
        flex-wrap: nowrap;
        justify-content: center;
    }

    .contact-strip-zh .bottom2_qr img {
        max-width: 120px;
    }

    .contact-strip-zh .bottom2_right {
        width: 100%;
        padding-top: 0;
    }

    .contact-strip-zh .bottom2_right > div {
        width: 100%;
        margin-bottom: 0;
    }

    .contact-strip-zh .bottom2_right > div span {
        margin-right: 20px;
        width: 100%;
        display: block;
    }
}

/* English footer style: follows D:\chat\qq\bottom_en2\bottom_en2.html */
.contact-strip-en {
    padding: 40px 10%;
}

.contact-strip-en .contact-shell {
    font-size: 16px;
    line-height: 40px;
}

.contact-strip-en .bottom2_qr {
    width: 30%;
    justify-content: center;
}

.contact-strip-en .bottom2_qr img {
    max-width: 180px;
}

.contact-strip-en .bottom2_qr span {
    line-height: 20px;
    margin-top: 20px;
}

.contact-strip-en .bottom2_right {
    width: 70%;
    padding-top: 10px;
}

.contact-strip-en .bottom2_right > div {
    width: 100%;
    margin-bottom: 20px;
}

.contact-strip-en .bottom2_right > div span {
    margin-right: 50px;
    width: auto;
    display: inline;
}

@media (min-width: 1200px) and (max-width: 1399px) {
    .contact-strip-en {
        padding: 40px 5%;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .contact-strip-en {
        padding: 20px 2%;
    }

    .contact-strip-en .contact-shell {
        font-size: 15px;
        line-height: 30px;
    }

    .contact-strip-en .bottom2_qr img {
        max-width: 160px;
    }

    .contact-strip-en .bottom2_right > div {
        margin-bottom: 10px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .contact-strip-en {
        padding: 20px 1%;
    }

    .contact-strip-en .contact-shell {
        font-size: 15px;
        line-height: 30px;
    }

    .contact-strip-en .bottom2_qr {
        width: 40%;
    }

    .contact-strip-en .bottom2_right {
        width: 60%;
    }

    .contact-strip-en .bottom2_qr img {
        max-width: 160px;
    }

    .contact-strip-en .bottom2_right > div {
        margin-bottom: 10px;
    }
}

@media (min-width: 601px) and (max-width: 767px) {
    .contact-strip-en {
        padding: 20px 2%;
    }

    .contact-strip-en .contact-shell {
        flex-wrap: wrap;
        font-size: 15px;
        line-height: 30px;
    }

    .contact-strip-en .bottom2_qr {
        width: 100%;
        max-width: 767px;
        flex-wrap: nowrap;
        justify-content: center;
    }

    .contact-strip-en .bottom2_qr img {
        max-width: 150px;
    }

    .contact-strip-en .bottom2_right {
        width: 100%;
    }

    .contact-strip-en .bottom2_right > div {
        margin-bottom: 0;
    }

    .contact-strip-en .bottom2_right > div span {
        margin-right: 30px;
    }
}

@media screen and (max-width: 600px) {
    .contact-strip-en {
        padding: 20px 2%;
    }

    .contact-strip-en .contact-shell {
        flex-wrap: wrap;
        font-size: 14px;
        line-height: 30px;
    }

    .contact-strip-en .bottom2_qr {
        width: 100%;
        max-width: 767px;
        flex-wrap: nowrap;
        justify-content: center;
    }

    .contact-strip-en .bottom2_qr img {
        max-width: 120px;
        display: block;
    }

    .contact-strip-en .bottom2_right {
        width: 100%;
    }

    .contact-strip-en .bottom2_right > div {
        width: 100%;
        display: block;
        margin-bottom: 0;
    }

    .contact-strip-en .bottom2_right > div span {
        margin-right: 30px;
        width: 100%;
        display: block;
    }
}

::v-deep(.home-header .info) {
    height: 70px;
    align-items: center;
    justify-content: center;
    padding: 0 46px;
    background: #47237a;
    position: relative;
}

::v-deep(.home-header .sign) {
    height: 64px !important;
}

::v-deep(.home-header .logo),
::v-deep(.home-header .login),
::v-deep(.home-header .info > .select) {
    display: none;
}

::v-deep(.home-header .nav) {
    padding-left: 0;
    gap: 84px;
}

::v-deep(.home-header .nav .item-info) {
    padding: 0;
    line-height: 64px;
}

::v-deep(.home-header .nav .item-info .title) {
    font-size: 21px;
    color: #ffffff;
    font-weight: 500;
    letter-spacing: 0.5px;
}

::v-deep(.home-header .nav #active),
::v-deep(.home-header .nav .item-info:hover) {
    background: transparent;
}

::v-deep(.home-header .nav #active .title),
::v-deep(.home-header .nav .item-info:hover .title),
::v-deep(.home-header .nav #active .nav-arrow),
::v-deep(.home-header .nav) {
    color: #2ce1ff;
}

::v-deep(.item-info:hover .nav-arrow) {
    color: #184ef6;
}

::v-deep(.home-header .nav .nav-arrow) {
    color: rgba(255, 255, 255, 0.92);
    width: 9px;
    height: 9px;
    margin-left: 10px;
    margin-top: -6px;
    border-right-width: 2px;
    border-bottom-width: 2px;
}

::v-deep(.home-header .nav .select) {
    margin-top: 0;
    padding: 8px 0;
    background: rgba(52, 28, 95, 0.96);
    box-shadow: 0 10px 24px rgba(21, 11, 43, 0.24);
}

::v-deep(.home-header .nav .select .select-item) {
    color: #ffffff;
    padding: 12px 20px 12px 16px;
}

::v-deep(.home-header .nav .select .select-item:hover) {
    background: rgba(44, 225, 255, 0.16);
    color: #2ce1ff;
}

::v-deep(.home-header .language) {
    height: 26px;
    margin-left: 54px;
    padding-left: 20px;
    line-height: 26px;
}

::v-deep(.home-header .language .sign),
::v-deep(.home-header .language .text) {
    color: #ffffff;
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 1px;
}

::v-deep(.home-header .language #langactive) {
    color: #2ce1ff;
}

@media (max-width: 1600px) {
    ::v-deep(.home-header .info) {
        padding: 0 28px;
    }

    ::v-deep(.home-header .nav) {
        gap: 50px;
        margin-left: -20px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 18px;
    }

    ::v-deep(.home-header .language) {
        margin-left: 32px;
        padding-left: 18px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 18px;
    }
}

@media (max-width: 1366px) {
    ::v-deep(.home-header .info) {
        padding: 0 28px;
    }

    ::v-deep(.home-header .nav) {
        gap: 48px;
        margin-left: -70px !important;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 18px;
    }

    ::v-deep(.home-header .language) {
        margin-left: 50px;
        padding-left: 18px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 18px;
    }
}

@media (max-width: 1200px) {
    ::v-deep(.home-header .info) {
        padding: 0 20px;
    }

    ::v-deep(.home-header .nav) {
        gap: 24px;
        justify-content: center;
        flex-wrap: wrap;
    }

    ::v-deep(.home-header .nav .item-info) {
        line-height: 56px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 16px;
    }

    ::v-deep(.home-header .language) {
        position: static;
        margin-left: 0;
        padding-left: 0;
        line-height: 56px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 16px;
    }
}

@media (max-width: 992px) {
    ::v-deep(.home-header .info) {
        height: auto;
        padding: 12px 18px;
        flex-wrap: wrap;
        row-gap: 10px;
    }

    ::v-deep(.home-header .sign) {
        height: auto !important;
    }

    ::v-deep(.home-header .nav) {
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
        gap: 12px 20px;
    }

    ::v-deep(.home-header .nav .item-info) {
        line-height: 1.4;
    }

    ::v-deep(.home-header .language) {
        width: 100%;
        justify-content: center;
        line-height: 1.4;
    }
}

@media (max-width: 768px) {
    ::v-deep(.home-header .info) {
        padding: 10px 14px;
    }

    ::v-deep(.home-header .nav) {
        gap: 10px 16px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 14px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 14px;
    }
}

@media (max-width: 576px) {
    ::v-deep(.home-header .nav) {
        gap: 8px 12px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 13px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 13px;
    }
}
</style>
